export const CATEGORY_TYPE = {
  AUTOMOTIVE: 'AUTOMOTIVE',
  NON_AUTOMOTIVE: 'NON_AUTOMOTIVE',
} as const;

export type CategoryType = (typeof CATEGORY_TYPE)[keyof typeof CATEGORY_TYPE];

interface AutomotiveFlag {
  isAutomotive?: boolean;
}

export const isAutomotiveCategory = (
  category?: AutomotiveFlag | null
): boolean => {
  return category?.isAutomotive !== false;
};

export const categoryTypeOf = (category: AutomotiveFlag): CategoryType => {
  return isAutomotiveCategory(category)
    ? CATEGORY_TYPE.AUTOMOTIVE
    : CATEGORY_TYPE.NON_AUTOMOTIVE;
};

export const filterCategoriesByType = <T extends AutomotiveFlag>(
  categories: readonly T[],
  type: CategoryType | null
): T[] => {
  if (!type) return [];
  return categories.filter((category) => {
    const automotive = isAutomotiveCategory(category);
    switch (type) {
      case CATEGORY_TYPE.AUTOMOTIVE:
        return automotive;
      case CATEGORY_TYPE.NON_AUTOMOTIVE:
        return !automotive;
      default: {
        const unexpected: never = type;
        return unexpected;
      }
    }
  });
};

export const soleEntry = <T>(items: readonly T[] | undefined): T | null => {
  if (items?.length === 1) return items[0];
  return null;
};

export type AskingPriceResult =
  | { status: 'empty' }
  | { status: 'invalid' }
  | { status: 'valid'; price: number };

export const parseAskingPrice = (value: string): AskingPriceResult => {
  if (value === '') return { status: 'empty' };
  const price = Number(value);
  if (Number.isNaN(price) || price < 0) return { status: 'invalid' };
  return { status: 'valid', price };
};
